module.exports = __webpack_public_path__ + "static/img/industry_bg.a57789c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/industry_bg.png
// module id = Hsaj
// module chunks = 0